import { render, staticRenderFns } from "./LiveStageRouteForm.vue?vue&type=template&id=21c80cea"
import script from "./LiveStageRouteForm.vue?vue&type=script&lang=js"
export * from "./LiveStageRouteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports